import { formatDateTime } from '@dataGrid/gridUtilities';
import { withStyles, Divider } from '@material-ui/core';
import CustomerClosedBadge from "./Holidays/components/CustomerClosedBadge";

const styles = (theme) => ({
  dialogTitle: {
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    textAlign: 'left',
    display: 'flex',
    padding: '0px 0px',
    color: theme.HeaderSelectedText
  },
  dialogContent: {
    color: theme.iconColor,
    fontSize: theme.headerTextFontSize
  },
  dialogContentColor: {
    color: theme.HeaderSelectedText,
    paddingTop: 6,
    paddingBottom: 10
  },
  divider: {
    borderBottom: `1px solid ${theme.gridIconBorderColor}`,
    width: '100%',
    opacity: '0.7',
    height: '0px'
  }
});

const Header = (props) => {
  const { data, address, handleClose, classes, userName, dateTime } = props;

  const getLasModifiedDetails = () => {
    if (!dateTime || !userName) {
      return '';
    }
    const formattedDateTime = formatDateTime({
      value: dateTime
    })
      .split(' ')
      .join(' | ');
    return `Last modified on: ${formattedDateTime} by ${userName}`;
  };

  return (
    <>
      <div className={classes.dialogTitle} id="dialog-title" onClose={handleClose}>
        {data.name} {`#${data.code}`}
      </div>
      <div className={classes.dialogContent}>
        {address}
        <div className={classes.dialogContentColor}>{getLasModifiedDetails()}</div>
      </div>
      <CustomerClosedBadge data={data}/>
      <Divider className={classes.divider} />
    </>
  );
};

export default withStyles(styles)(Header);
